import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronLeft, Flame, Crown, Medal } from "lucide-react";
import api from "../lib/api";
import { useT } from "../context/LanguageContext";
import TopBar from "../components/TopBar";

export default function Leaderboard() {
  const navigate = useNavigate();
  const t = useT();
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/leaderboard").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="space-bg min-h-screen flex items-center justify-center text-white/60">{t("Caricamento...")}</div>;

  const rankColor = (i) => (i === 0 ? "#FFD700" : i === 1 ? "#C0C0C0" : i === 2 ? "#CD7F32" : "rgba(255,255,255,0.4)");

  return (
    <div className="space-bg min-h-screen pb-16">
      <TopBar showLeaderboard={false} />
      <div className="max-w-lg mx-auto px-4 pt-5">
        <button onClick={() => navigate("/dashboard")} className="flex items-center gap-1 text-white/60 bouncy mb-4" data-testid="lb-back-btn">
          <ChevronLeft size={18} /> {t("Home")}
        </button>
        <h1 className="font-heading font-black text-3xl tracking-tight mb-6 flex items-center gap-2">
          <Crown style={{ color: "var(--gold)" }} /> {t("Classifica")}
        </h1>
        <div className="space-y-2">
          {data.leaderboard.map((u, i) => (
            <motion.div key={u.user_id} initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.04 }}
              className={`glass rounded-2xl px-4 py-3 flex items-center gap-3 ${u.user_id === data.me ? "glow-cyan" : ""}`}
              data-testid={`lb-row-${i}`}>
              <div className="w-7 text-center font-num font-bold" style={{ color: rankColor(i) }}>
                {i < 3 ? <Medal size={20} style={{ color: rankColor(i) }} /> : i + 1}
              </div>
              {u.picture ? <img src={u.picture} alt="" className="w-9 h-9 rounded-full" /> :
                <div className="w-9 h-9 rounded-full flex items-center justify-center font-heading font-bold" style={{ background: "var(--violet)" }}>{u.name?.[0]?.toUpperCase()}</div>}
              <div className="flex-1">
                <p className="font-heading font-bold leading-tight">{u.name} {u.user_id === data.me && <span className="text-xs text-white/50">{t("(tu)")}</span>}</p>
                <p className="text-xs text-white/50 font-num flex items-center gap-2">Lv {u.level} <span className="flex items-center gap-0.5"><Flame size={12} style={{ color: "#FF7A00" }} /> {u.streak}</span></p>
              </div>
              <div className="font-num font-bold" style={{ color: "var(--cyan)" }}>{u.xp} XP</div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
